import Vue from 'vue'
import VueI18n from 'vue-i18n'
import uz_cyrl from './translate/uz_cyrl.json'
import uz_latn from './translate/uz_latn.json'
import ru from "./translate/ru.json";
import { LOCALES, DEFAULT_LOCALE, localeFromPath } from "../plugins/i18n-routing";

Vue.use(VueI18n);

// Til manbai — URL. Prefiks bo'lmasa (standart til yoki boshqa sahifa),
// localStorage'dagi tanlovga qaytamiz. Aks holda foydalanuvchi /ru/news
// linkini ochganda o'z localStorage tilida ko'rar edi.
function resolveInitialLocale() {
  const path = typeof window !== "undefined" ? window.location.pathname : "/";
  const fromPath = localeFromPath(path);
  if (fromPath !== DEFAULT_LOCALE) return fromPath;
  const stored = localStorage.getItem("locale");
  return LOCALES[stored] ? stored : DEFAULT_LOCALE;
}

const locale = resolveInitialLocale();
localStorage.setItem("locale", locale);

const messages = {
  uz_cyrl: uz_cyrl,
  uz_latn: uz_latn,
  ru: ru,
};
const i18n = new VueI18n({
  locale,
  messages,
});

export default i18n;
